import { AccountPosition } from '../../type';
import { computePositionsValueForYield, computePositionsYieldWeightedByValue } from '../positionValue';

export const computeAverageYield = (positions: AccountPosition[] | null | undefined) => {
  const totalValuationWithMtInt = computePositionsValueForYield(positions);
  const totalWeightedByYtmValuationWithMtInt = computePositionsYieldWeightedByValue(positions);
  return totalValuationWithMtInt !== 0 ? (totalWeightedByYtmValuationWithMtInt / totalValuationWithMtInt) : 0;
};
